import React from "react";
import {  Nav } from "react-bootstrap";

const submenuData = [
    {
      name: "YouTube",
      subMenu: [
        {
          name: "Scheduled and Publishing",
          desc: "Schedule videos to publish automatically.",
          href: "/youtube-scheduled-publishing",
        },
        {
          name: "Subscription Tracker",
          desc: "Monitor your channel subscribers and growth trends.",
          href: "/youtube-subscription-tracker",
        },
        {
          name: "Trending Tags and Search",
          desc: "Find popular and high-performing tags.",
          href: "/youtube-trending-tags-finder",
        },
        {
          name: "Bix Intelligence",
          desc: "Get AI-driven recommendations for content optimization.",
          href: "/youtube-bix-intelligence",
        },
        {
          name: "Content Planner",
          desc: "Plan and organize your video content ideas.",
          href: "/youtube-content-planner",
        },
        {
          name: "Insight Analyzer",
          desc: "Track video performance, audience stats, and engagement.",
          href: "/youtube-insight-analyzer",
        },
      ],
    },
    {
      name: "Facebook",
      subMenu: [
        {
          name: "Profile & Page Analyzer",
          desc: "Evaluate page performance, engagement, and reach.",
          href: "/facebook-profile-page-analyzer",
        },
        {
          name: "Post & Content Creator",
          desc: "Create posts, images, and videos optimized for Facebook.",
          href: "/facebook-post-content-creator",
        },
        {
          name: "Post Scheduler",
          desc: "Schedule posts for peak engagement times.",
          href: "/facebook-post-scheduler",
        },
        {
          name: "Hashtag Finder",
          desc: "Discover trending and niche-specific hashtags.",
          href: "/facebook-hashtag-finder",
        },
      ],
    },
    {
      name: "LinkedIn",
      subMenu: [
        {
          name: "Profile Analyzer",
          desc: "Assess profile strength and optimization opportunities.",
          href: "/linkedin-profile-analyzer",
        },
        {
          name: "Post & Article Creator",
          desc: "Create professional posts and long-form articles.",
          href: "/linkedin-post-article-creator",
        },
        {
          name: "Post Scheduler",
          desc: "Schedule updates, posts, and articles efficiently.",
          href: "/linkedin-post-scheduler",
        },
        {
          name: "Hashtag Research Tool",
          desc: "Find relevant and trending LinkedIn hashtags.",
          href: "/linkedin-hashtag-research-tool",
        },
      ],
    },
    {
      name: "Instagram",
      subMenu: [
        {
          name: "Profile Analyzer",
          desc: "Evaluate your profile performance and growth potential.",
          href: "/instagram-profile-analyzer",
        },
        {
          name: "Post & Reel Creator",
          desc: "Create high-quality posts and reels with ease.",
          href: "/instagram-post-reel-creator",
        },
        {
          name: "Post Scheduler",
          desc: "Schedule your posts and reels for optimal engagement.",
          href: "/instagram-post-scheduler",
        },
        {
          name: "Hashtag Generator",
          desc: "Discover trending and niche-specific hashtags.",
          href: "/instagram-hashtag-generator",
        },
        {
          name: "Tag Analyzer",
          desc: "Analyze hashtags and tags for maximum reach.",
          href: "/instagram-tag-analyzer",
        },
      ],
    },
  ];
  

const Smotooltab = () => {
  const currentPath = window.location.pathname;
  return (
    <div
      className="px-4 bg-light"
      style={{ minHeight: "100vh", borderRight: "1px solid #dee2e6" }}
    >
      {submenuData.map((section, index) => (
        <div key={index} className="mb-2">
          <Nav className="flex-column">
            {section.subMenu.map((item, idx) => {
              const isActive = currentPath === item.href;

              return (
                <a
                  key={idx}
                  href={item.href}
                  title={item.desc}
                  className={`nav-link px-3 py-2 mb-1 rounded ${
                    isActive
                      ? "bg-primary text-white fw-bold border-start border-4 border-white"
                      : "text-dark"
                  }`}
                  style={{
                    fontSize: "0.95rem",
                    transition: "background 0.2s ease",
                  }}
                >
                  {item.name}
                </a>
              );
            })}
          </Nav>
        </div>
      ))}
    </div>
  );
};

export default Smotooltab;
